<app-modals [title]="title" [description]="description" [openModal]="openModal" [closeModal]="closeModal" [whenModalClose]="whenModalClose" [submitKey]="submitKey" [invalidFormGroup]="$safeNavigationMigration(entry?.invalid)" [isButtonsDisabled]="isButtonsDisabled" [onDismiss]="onDismiss" [isShaking]="$safeNavigationMigration(errors?.length) &gt; 0">
  <form #entityForm="ngForm" [formGroup]="entry" (ngSubmit)="onSubmit(entry)" novalidate="novalidate">@if (errors?.length > 0) {
    <app-form-errors [errors]="errors"></app-form-errors>
  }
  <div class="row">
    <div class="col-12 col-md-6"><app-forms-form-group [value]="entry.get('type')" fieldName="type" [fieldLabel]="'MODALS.EXPORT.TABLES' | translate"><select class="form-control form-select" id="type" formControlName="type" (change)="selectFields()">
      <option value="" disabled="disabled" checked="checked" selected="selected">{{ 'PLACEHOLDERS.TABLES' | translate }}</option>
      @for (t of tables; track t) {
        <option [value]="t.type">{{ t.label | titlecase }}</option>
      }
    </select></app-forms-form-group></div>
    <div class="col-12 col-md-6"><app-forms-form-group [value]="entry.get('dateRange')" fieldName="daterange" [fieldLabel]="'MODALS.EXPORT.DATE_RANGE' | translate"><input class="form-control bg-white" #dp="bsDaterangepicker" type="text" readonly="readonly" bsDaterangepicker="bsDaterangepicker" formControlName="dateRange" placeholder="daterange" [bsConfig]="bsConfig" value="entryDates.get('dateRange').value[0] + ' - ' + entryDates.get('dateRange').value[1]" /></app-forms-form-group></div>
  </div>
  @if (entry.get('type').value === 'referenceAnswersPerCandidates') {
    <div class="row">
      <div class="col-12 col-md-6"><app-forms-form-group [value]="entry.get('question_set_id')" fieldName="question_set_id" [fieldLabel]="'COMMON.QUESTION_SET' | translate" [isRequired]="false"><select class="form-control form-select" id="question_set_id" formControlName="question_set_id">
        <option value="">{{ 'MODALS.EXPORT.ALL_QUESTION_SETS' | translate }}</option>
        @for (qs of questionSets; track qs) {
          <option [value]="qs.id">{{ qs.title }}</option>
        }
      </select></app-forms-form-group></div>
    </div>
  }
  <div class="row">
    <div class="col-12">
      <div class="h6">{{ 'MODALS.EXPORT.FIELDS' | translate }}</div>
      @if (fields.length === 0) {
        <div>-</div>
      }
      @if (fields.length > 0) {
        <div class="row">
          @for (f of fields; track f; let index = $index) {
            <div class="col-12 col-md-6">
              <div class="form-check"><input class="form-check-input" [id]="'field' + index" type="checkbox" (change)="selectField(f)" /><label class="form-check-label" [for]="'field' + index">{{ f }}</label></div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</form>
</app-modals>
